/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.scss'
import BaseComponent from '@base/BaseComponent'
import { isEmpty } from 'lodash'
import { IconCodeEmum, Iconfont } from '@src/components'
import { Modal } from 'antd-mobile'
import EmptyImage from '@assets/images/empty-placeholder-3.png'

// 权益券列表、优惠券列表、优惠活动列表
class ActivityModal extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		emptyText: PropTypes.string,
		list: PropTypes.array,
		close: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		title: '',
		emptyText: '',
		list: [],
		close: () => {},
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 生命周期 */
	constructor(props) {
		super(props)
		this.state = {
			activeIndex: -1,
		}
	}

	componentDidUpdate() {}

	handleItTap(index) {
		const { activeIndex } = this.state
		let idx = -1
		if (activeIndex === index) {
			idx = -1
		} else {
			idx = index
		}
		this.setState({
			activeIndex: idx,
		})
	}

	render() {
		let { isShow, list, close, title, emptyText } = this.props
		// console.log('activityList === ', list)

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modalActivity}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<div className={CSS.scrollViewComp}>
					<div className={CSS.modalTitle}>
						<label>{title}</label>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{ fontSize: '.32rem', color: '#D8D8D8' }}
							onPress={close.bind(this)}
						/>
					</div>
					<div className={CSS.scrollView}>
						{!isEmpty(list) ? (
							<div className={CSS.ls}>
								{list &&
									list.map((item, index) => (
										<div
											className={CSS.it}
											key={index}
											onClick={this.handleItTap.bind(this, index)}
										>
											<div className={CSS.itlf}>
												<div className={CSS.ittt}>{item.title || ''}</div>
												<div className={CSS.itvalue}>{item.desc || ''}</div>
											</div>
										</div>
									))}
							</div>
						) : null}

						{isEmpty(list) ? (
							<div className={CSS.empty}>
								<img
									src={EmptyImage}
									mode='aspectFill'
									className={CSS.emptyImg}
									alt='empty-image'
								/>
								<div>{emptyText}</div>
							</div>
						) : null}
					</div>
				</div>
			</Modal>
		)
	}
}

export default ActivityModal
